import * as Yup from 'yup';

export const DacaSchema = Yup.object().shape({
	nome: Yup.string().trim()
		.required('Campo obrigatório'),
	descricao: Yup.string().trim()
		.required('Campo obrigatório'),
	tiposExibicao: Yup.array().of(Yup.string())
		.required('Campo obrigatório'),
	permanente: Yup.boolean().required('Campo obrigatório'),
}, [['permanente']]);
